class sertitleanim {
    constructor(element) {
        this.element = element;
        this.sertitleAnim = this.element.querySelectorAll('.sec-header-content-anim-line');
        this.titleTrigger = this.element.querySelectorAll('.service-page-list-content-header');
        this.serpointAnim = this.element.querySelectorAll('.service-page-list-content-point ul li');
        this.serpointTrigger = this.element.querySelectorAll('.service-page-list-content-point');
        this.init();
    }

    init() {
        const serviceListanim = gsap.timeline({ paused: true });
        serviceListanim.fromTo(this.sertitleAnim, {
            x: 0,
            y: 49,
            z: -41,
            rotationX: -80,
            transformOrigin: '50% 0%',
            opacity: 0,
        },
            {
                x: 0,
                y: 0,
                z: 0,
                rotationX: 0,
                transformOrigin: '318px 30px',
                opacity: 1,
                stagger: 0.05,
                duration: 0.9,
                ease: 'power4.out'
            })
        ScrollTrigger.create({
            trigger: this.titleTrigger,
            start: '-10% 90%',
            end: '100% 60%',
            // markers: true,
            onEnter: () => serviceListanim.play(),
            onLeaveBack: () => serviceListanim.reverse()
        })

        const serviceListpointanim = gsap.timeline({ paused: true });
        serviceListpointanim.fromTo(this.serpointAnim, {
            x: -100,
            opacity: 0,
        },
            {
                x: 0,
                opacity: 1,
                stagger: 0.05,
                duration: 2,
                ease: 'bounce.out'
            })
        ScrollTrigger.create({
            trigger: this.serpointTrigger,
            start: '0% 70%',
            end: '100% 70%',
            // markers: true,
            onEnter: () => serviceListpointanim.play(),
            onLeaveBack: () => serviceListpointanim.reverse()
        })
    }
}
const servicePageList = document.querySelectorAll('.service-page-list');
servicePageList.forEach(function (servicePageListall) {
    new sertitleanim(servicePageListall);
});